import React from "react";
import PropTypes from "prop-types";
import { Card, CardContent, CardHeader } from "@mui/material";

import { clx } from "../../../utils/Helpers";

import "./UICard.scss";

const CARD_TYPES = new Set(["info", "success", "destructive"]);

const normalizeCardType = (type) => {
  if (!type) return "info";

  const normalized = String(type).toLowerCase();
  return CARD_TYPES.has(normalized) ? normalized : "info";
};

const UICard = ({
  title,
  subtitle,
  action,
  children,
  contentSx,
  type = "info",
  className,
  ...props
}) => {
  const normalizedType = normalizeCardType(type);
  const headerTypeClass = `ui-card__header--${normalizedType}`;

  return (
    <Card className={clx("ui-card", className)} {...props}>
      {(title || subtitle || action) && (
        <CardHeader
          className={headerTypeClass}
          title={title}
          subheader={subtitle}
          action={action}
        />
      )}
      <CardContent sx={contentSx}>{children}</CardContent>
    </Card>
  );
};

UICard.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  action: PropTypes.node,
  children: PropTypes.node,
  contentSx: PropTypes.object,
  type: PropTypes.oneOf(["info", "success", "destructive", "Success", "Destructive"]),
  className: PropTypes.string,
};

UICard.defaultProps = {
  title: null,
  subtitle: null,
  action: null,
  children: null,
  contentSx: undefined,
  type: "info",
  className: "",
};

export default UICard;
